<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import Toast from '@/components/common/Toast.vue'
import SessionTimeoutWarning from '@/components/common/SessionTimeoutWarning.vue'

const authStore = useAuthStore()

onMounted(async () => {
  // Check if user is logged in
  await authStore.checkAuth()
})
</script>

<template>
  <router-view />
  <Toast />
  <SessionTimeoutWarning />
</template>

<style>
#app {
  min-height: 100vh;
}
</style>
